<template>
  <div class="map-mode-switcher glass-panel" :class="{ 'is-mobile': isMobile }">
    <div 
      v-for="option in options" 
      :key="option.value"
      class="mode-option"
      :class="{ active: modelValue === option.value }"
      @click="$emit('update:modelValue', option.value)"
    >
      <span class="mode-icon">{{ option.icon }}</span>
      <span class="mode-label">{{ option.label }}</span>
    </div>
    <div class="active-indicator" :style="indicatorStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'MapModeSwitcher',
  props: {
    modelValue: {
      type: String,
      default: 'outline'
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      options: [
        { label: '二维', value: 'outline', icon: '平面' },
        { label: '三维', value: 'outline3d', icon: '视投' },
        { label: '卫星', value: 'satellite', icon: '遥感' }
      ]
    }
  },
  computed: {
    activeIndex() {
      return this.options.findIndex(opt => opt.value === this.modelValue)
    },
    indicatorStyle() {
      const step = 100 / this.options.length
      return {
        width: `${step}%`,
        left: `${this.activeIndex * step}%`
      }
    }
  }
}
</script>

<style scoped>
.map-mode-switcher {
  position: relative;
  display: flex;
  background: rgba(13, 20, 36, 0.75) !important;
  backdrop-filter: blur(16px) !important;
  -webkit-backdrop-filter: blur(16px) !important;
  border: 1px solid rgba(0, 240, 255, 0.3) !important;
  border-radius: 99px !important;
  padding: 0 !important;
  gap: 0 !important;
  overflow: hidden !important;
  pointer-events: auto !important;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.6), inset 0 0 0 1px rgba(255, 255, 255, 0.05) !important;
  user-select: none;
  width: fit-content;
}

.mode-option {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  min-width: 80px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 99px;
}

.mode-icon {
  font-size: 0.7rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 3px;
  letter-spacing: 1px;
}

.mode-label {
  font-size: 1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 2px;
}

.mode-option:hover .mode-icon,
.mode-option:hover .mode-label {
  color: #fff;
}

.mode-option.active .mode-icon {
  color: rgba(255, 255, 255, 0.9);
}

.mode-option.active .mode-label {
  color: #ffffff;
  font-weight: 700;
}

.active-indicator {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  background: linear-gradient(180deg, rgba(0, 212, 255, 0.25) 0%, rgba(0, 153, 255, 0.45) 100%);
  border-left: 1px solid rgba(0, 212, 255, 0.4);
  border-right: 1px solid rgba(0, 212, 255, 0.4);
  transition: all 0.35s cubic-bezier(0.25, 1, 0.5, 1);
  box-shadow: inset 0 0 15px rgba(0, 153, 255, 0.2);
}

/* Mobile adjustments */
.is-mobile {
  padding: 2px !important;
  gap: 2px !important;
}

.is-mobile .mode-option {
  padding: 6px 12px;
  min-width: 50px;
}

.is-mobile .mode-label {
  font-size: 0.85rem;
}

.is-mobile .mode-icon {
  font-size: 0.65rem;
}
</style>
